import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'Home',
            component: () =>
                import ('@/views/Home'),
        },
        {
            path: '/Home', //登录
            name: 'Home',
            component: () =>
                import ('@/views/Home'),
        },
        {
            path: '/jobSearch',
            name: 'jobSearch',
            component: () =>
                import ('@/views/jobSearch/index')
        },
        {
            path: '/findAworker',
            name: 'findAworker',
            component: () =>
                import ('@/views/findAworker/findAworker')
        },
        {
            path: '/perDetail',
            name: 'perDetail',
            component: () =>
                import ('@/views/findAworker/perDetail')
        },
        {
            path: '/jobSearchDetail',
            name: 'jobSearchDetail',
            component: () =>
                import ('@/views/jobSearch/detail')
        },
        {
            path:'/companyDetail',
            name:'companyDetail',
            component: () =>
                import ('@/views/jobSearch/companyMsg')
        },{
            path:'/cmpyDetail',
            name:'cmpyDetail',
            component: () =>
                import ('@/views/findAworker/companyDetail')
        }]
    })



// WEBPACK FOOTER //
// ./src/router/index.js